import { combineReducers } from "redux"
import auth from "./authReducer"
import productReducer from "./productReducer"
export default combineReducers({
    auth,
    product: productReducer,
})
